var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedBonusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.4,
    fill: "url(#paint0_linear_5035_728)",
    stroke: "#FFD569",
    strokeWidth: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3626 22.2222H20.638C21.0222 22.2222 21.3337 21.9328 21.3337 21.5758V14.2492C21.3337 13.8921 21.0222 13.6027 20.638 13.6027H19.9424V11.6633C19.9424 9.64336 18.174 8 16.0003 8C13.8267 8 12.0583 9.64336 12.0583 11.6633V13.6027H11.3626C10.9785 13.6027 10.667 13.8921 10.667 14.2492V21.5758C10.667 21.9328 10.9785 22.2222 11.3626 22.2222ZM16.696 18.1273V18.9899C16.696 19.3469 16.3845 19.6364 16.0003 19.6364C15.6161 19.6364 15.3047 19.3469 15.3047 18.9899V18.1273C15.0233 17.9306 14.8409 17.6178 14.8409 17.266C14.8409 16.6719 15.361 16.1886 16.0003 16.1886C16.6396 16.1886 17.1597 16.6719 17.1597 17.266C17.1597 17.6178 16.9774 17.9306 16.696 18.1273ZM13.4496 11.6633C13.4496 10.3563 14.5939 9.29293 16.0003 9.29293C17.4068 9.29293 18.5511 10.3563 18.5511 11.6633V13.6027H13.4496V11.6633Z",
    fill: "#764E0D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5035_728",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedBonusIcon);
export default __webpack_public_path__ + "static/media/lockedBonusIcon.a10737c0fd69a007c84504a76aff5228.svg";
export { ForwardRef as ReactComponent };